import { customInstance } from "../../custom-instance";
export const get = () => {
    const approvalLineControllerGetApprovalLine = (documentType, documentId) => {
        return customInstance({
            url: `/approval-line/${documentType}/${documentId}`,
            method: "GET",
        });
    };
    const approvalLineControllerGetMyPending = (params) => {
        return customInstance({
            url: `/approval-line/my-pending`,
            method: "GET",
            params,
        });
    };
    const approvalLineControllerPatchApprove = (stepId, processApprovalStepDto) => {
        return customInstance({
            url: `/approval-line/step/${stepId}/approve`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: processApprovalStepDto,
        });
    };
    const approvalLineControllerPatchReject = (stepId, processApprovalStepDto) => {
        return customInstance({
            url: `/approval-line/step/${stepId}/reject`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: processApprovalStepDto,
        });
    };
    const approvalLineControllerPatchResubmit = (documentType, documentId) => {
        return customInstance({
            url: `/approval-line/${documentType}/${documentId}/resubmit`,
            method: "PATCH",
        });
    };
    return {
        approvalLineControllerGetApprovalLine,
        approvalLineControllerGetMyPending,
        approvalLineControllerPatchApprove,
        approvalLineControllerPatchReject,
        approvalLineControllerPatchResubmit,
    };
};
